/* THIS IS A GENERATED FILE, DO NOT EDIT */
import * as GraphqlTypes from "./supergraphTypes";
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export const IngestionDocumentFieldsFragmentDoc = gql`
    fragment IngestionDocumentFields on IngestionDocument {
  id
  filename
  status
  classification {
    state
    documentType
    entityId
    entityName
    reportingDate
    confidence
    failureReason
  }
}
    `;
export const ClassificationPayloadFragmentDoc = gql`
    fragment ClassificationPayload on NodePayload {
  __typename
  ... on DocumentClassificationCard {
    state
    documentType
    entityId
    entityName
    reportingDate
    confidence
    failureReason
  }
}
    `;
export const PackageDetailFieldsFragmentDoc = gql`
    fragment PackageDetailFields on DeliverablePackageDetail {
  id
  reportingDate
  packageType
  publishState
  publishStateChangedAt
  actorCapabilities
  enumerationStatus
  executiveSummary {
    text
    generatedAt
    isStale
  }
  executiveSummaryStatus
  entity {
    id
    name
    isFaLocked
  }
  findings {
    findingId
  }
  documents {
    id
    documentId
    documentVersion
    lifecycleStage
    gating {
      gatingReason
    }
    metadata {
      id
      originalFilename
      documentType
      uploadedAt
      uploadedByUserId
    }
    sections {
      key
      details {
        label
        firstPage
        lastPage
      }
      checks {
        checkId
        findingId
        checkName
        kind
        source
        outcome
        severity
        message
        expectedValue
        actualValue
        triageState
        isOpen
        feedback {
          rating
          note
          updatedByUserId
          updatedAt
        }
        rowLabel
        delta
        componentValues {
          label
          value
          rowIndex
          colIndex
        }
        issues {
          kind
          ... on DollarSignCellIssue {
            rowLabel
            columnHeader
            rawText
            violation
          }
        }
      }
    }
  }
}
    `;
export const DocDocGoGeneratePresignedUrlsDocument = gql`
    mutation DocDocGoGeneratePresignedUrls($files: [DocDocGoPresignedUrlInput!]!) {
  docDocGoGeneratePresignedUrls(files: $files) {
    s3Url
    objectKey
    filename
  }
}
    `;
export type DocDocGoGeneratePresignedUrlsMutationFn = Apollo.MutationFunction<GraphqlTypes.DocDocGoGeneratePresignedUrlsMutation, GraphqlTypes.DocDocGoGeneratePresignedUrlsMutationVariables>;

/**
 * __useDocDocGoGeneratePresignedUrlsMutation__
 *
 * To run a mutation, you first call `useDocDocGoGeneratePresignedUrlsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDocDocGoGeneratePresignedUrlsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [docDocGoGeneratePresignedUrlsMutation, { data, loading, error }] = useDocDocGoGeneratePresignedUrlsMutation({
 *   variables: {
 *      files: // value for 'files'
 *   },
 * });
 */
export function useDocDocGoGeneratePresignedUrlsMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.DocDocGoGeneratePresignedUrlsMutation, GraphqlTypes.DocDocGoGeneratePresignedUrlsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.DocDocGoGeneratePresignedUrlsMutation, GraphqlTypes.DocDocGoGeneratePresignedUrlsMutationVariables>(DocDocGoGeneratePresignedUrlsDocument, options);
      }
export type DocDocGoGeneratePresignedUrlsMutationHookResult = ReturnType<typeof useDocDocGoGeneratePresignedUrlsMutation>;
export type DocDocGoGeneratePresignedUrlsMutationResult = Apollo.MutationResult<GraphqlTypes.DocDocGoGeneratePresignedUrlsMutation>;
export type DocDocGoGeneratePresignedUrlsMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.DocDocGoGeneratePresignedUrlsMutation, GraphqlTypes.DocDocGoGeneratePresignedUrlsMutationVariables>;
export const StartDocumentBatchIngestionDocument = gql`
    mutation StartDocumentBatchIngestion($input: StartDocumentBatchIngestionInput!) {
  startDocumentBatchIngestion(input: $input) {
    id
    state
    receivedAt
    documentCount
    classifiedCount
  }
}
    `;
export type StartDocumentBatchIngestionMutationFn = Apollo.MutationFunction<GraphqlTypes.StartDocumentBatchIngestionMutation, GraphqlTypes.StartDocumentBatchIngestionMutationVariables>;

/**
 * __useStartDocumentBatchIngestionMutation__
 *
 * To run a mutation, you first call `useStartDocumentBatchIngestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartDocumentBatchIngestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startDocumentBatchIngestionMutation, { data, loading, error }] = useStartDocumentBatchIngestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartDocumentBatchIngestionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.StartDocumentBatchIngestionMutation, GraphqlTypes.StartDocumentBatchIngestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.StartDocumentBatchIngestionMutation, GraphqlTypes.StartDocumentBatchIngestionMutationVariables>(StartDocumentBatchIngestionDocument, options);
      }
export type StartDocumentBatchIngestionMutationHookResult = ReturnType<typeof useStartDocumentBatchIngestionMutation>;
export type StartDocumentBatchIngestionMutationResult = Apollo.MutationResult<GraphqlTypes.StartDocumentBatchIngestionMutation>;
export type StartDocumentBatchIngestionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.StartDocumentBatchIngestionMutation, GraphqlTypes.StartDocumentBatchIngestionMutationVariables>;
export const DocumentIngestionsDocument = gql`
    query DocumentIngestions($arenaId: Int!, $limit: Int = 20, $pageToken: String) {
  documentIngestions(arenaId: $arenaId, limit: $limit, pageToken: $pageToken) {
    ingestions {
      id
      state
      receivedAt
      documentCount
      classifiedCount
    }
    nextPageToken
  }
}
    `;

/**
 * __useDocumentIngestionsQuery__
 *
 * To run a query within a React component, call `useDocumentIngestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentIngestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentIngestionsQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      limit: // value for 'limit'
 *      pageToken: // value for 'pageToken'
 *   },
 * });
 */
export function useDocumentIngestionsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.DocumentIngestionsQuery, GraphqlTypes.DocumentIngestionsQueryVariables> & ({ variables: GraphqlTypes.DocumentIngestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DocumentIngestionsQuery, GraphqlTypes.DocumentIngestionsQueryVariables>(DocumentIngestionsDocument, options);
      }
export function useDocumentIngestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DocumentIngestionsQuery, GraphqlTypes.DocumentIngestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DocumentIngestionsQuery, GraphqlTypes.DocumentIngestionsQueryVariables>(DocumentIngestionsDocument, options);
        }
// @ts-ignore
export function useDocumentIngestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DocumentIngestionsQuery, GraphqlTypes.DocumentIngestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DocumentIngestionsQuery, GraphqlTypes.DocumentIngestionsQueryVariables>;
export function useDocumentIngestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DocumentIngestionsQuery, GraphqlTypes.DocumentIngestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DocumentIngestionsQuery | undefined, GraphqlTypes.DocumentIngestionsQueryVariables>;
export function useDocumentIngestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DocumentIngestionsQuery, GraphqlTypes.DocumentIngestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DocumentIngestionsQuery, GraphqlTypes.DocumentIngestionsQueryVariables>(DocumentIngestionsDocument, options);
        }
export type DocumentIngestionsQueryHookResult = ReturnType<typeof useDocumentIngestionsQuery>;
export type DocumentIngestionsLazyQueryHookResult = ReturnType<typeof useDocumentIngestionsLazyQuery>;
export type DocumentIngestionsSuspenseQueryHookResult = ReturnType<typeof useDocumentIngestionsSuspenseQuery>;
export type DocumentIngestionsQueryResult = Apollo.QueryResult<GraphqlTypes.DocumentIngestionsQuery, GraphqlTypes.DocumentIngestionsQueryVariables>;
export const DocumentIngestionDocument = gql`
    query DocumentIngestion($arenaId: Int!, $id: ID!) {
  documentIngestion(arenaId: $arenaId, id: $id) {
    id
    state
    receivedAt
    documentCount
    classifiedCount
    documents {
      ...IngestionDocumentFields
    }
  }
}
    ${IngestionDocumentFieldsFragmentDoc}`;

/**
 * __useDocumentIngestionQuery__
 *
 * To run a query within a React component, call `useDocumentIngestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentIngestionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentIngestionQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentIngestionQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.DocumentIngestionQuery, GraphqlTypes.DocumentIngestionQueryVariables> & ({ variables: GraphqlTypes.DocumentIngestionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DocumentIngestionQuery, GraphqlTypes.DocumentIngestionQueryVariables>(DocumentIngestionDocument, options);
      }
export function useDocumentIngestionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DocumentIngestionQuery, GraphqlTypes.DocumentIngestionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DocumentIngestionQuery, GraphqlTypes.DocumentIngestionQueryVariables>(DocumentIngestionDocument, options);
        }
// @ts-ignore
export function useDocumentIngestionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DocumentIngestionQuery, GraphqlTypes.DocumentIngestionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DocumentIngestionQuery, GraphqlTypes.DocumentIngestionQueryVariables>;
export function useDocumentIngestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DocumentIngestionQuery, GraphqlTypes.DocumentIngestionQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DocumentIngestionQuery | undefined, GraphqlTypes.DocumentIngestionQueryVariables>;
export function useDocumentIngestionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DocumentIngestionQuery, GraphqlTypes.DocumentIngestionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DocumentIngestionQuery, GraphqlTypes.DocumentIngestionQueryVariables>(DocumentIngestionDocument, options);
        }
export type DocumentIngestionQueryHookResult = ReturnType<typeof useDocumentIngestionQuery>;
export type DocumentIngestionLazyQueryHookResult = ReturnType<typeof useDocumentIngestionLazyQuery>;
export type DocumentIngestionSuspenseQueryHookResult = ReturnType<typeof useDocumentIngestionSuspenseQuery>;
export type DocumentIngestionQueryResult = Apollo.QueryResult<GraphqlTypes.DocumentIngestionQuery, GraphqlTypes.DocumentIngestionQueryVariables>;
export const ReclassifyDocumentDocument = gql`
    mutation ReclassifyDocument($input: ReclassifyDocumentInput!) {
  reclassifyDocument(input: $input) {
    ...IngestionDocumentFields
  }
}
    ${IngestionDocumentFieldsFragmentDoc}`;
export type ReclassifyDocumentMutationFn = Apollo.MutationFunction<GraphqlTypes.ReclassifyDocumentMutation, GraphqlTypes.ReclassifyDocumentMutationVariables>;

/**
 * __useReclassifyDocumentMutation__
 *
 * To run a mutation, you first call `useReclassifyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReclassifyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reclassifyDocumentMutation, { data, loading, error }] = useReclassifyDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReclassifyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ReclassifyDocumentMutation, GraphqlTypes.ReclassifyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ReclassifyDocumentMutation, GraphqlTypes.ReclassifyDocumentMutationVariables>(ReclassifyDocumentDocument, options);
      }
export type ReclassifyDocumentMutationHookResult = ReturnType<typeof useReclassifyDocumentMutation>;
export type ReclassifyDocumentMutationResult = Apollo.MutationResult<GraphqlTypes.ReclassifyDocumentMutation>;
export type ReclassifyDocumentMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ReclassifyDocumentMutation, GraphqlTypes.ReclassifyDocumentMutationVariables>;
export const RemoveDocumentFromIngestionDocument = gql`
    mutation RemoveDocumentFromIngestion($arenaId: Int!, $documentId: ID!) {
  removeDocumentFromIngestion(arenaId: $arenaId, documentId: $documentId)
}
    `;
export type RemoveDocumentFromIngestionMutationFn = Apollo.MutationFunction<GraphqlTypes.RemoveDocumentFromIngestionMutation, GraphqlTypes.RemoveDocumentFromIngestionMutationVariables>;

/**
 * __useRemoveDocumentFromIngestionMutation__
 *
 * To run a mutation, you first call `useRemoveDocumentFromIngestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDocumentFromIngestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDocumentFromIngestionMutation, { data, loading, error }] = useRemoveDocumentFromIngestionMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useRemoveDocumentFromIngestionMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RemoveDocumentFromIngestionMutation, GraphqlTypes.RemoveDocumentFromIngestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RemoveDocumentFromIngestionMutation, GraphqlTypes.RemoveDocumentFromIngestionMutationVariables>(RemoveDocumentFromIngestionDocument, options);
      }
export type RemoveDocumentFromIngestionMutationHookResult = ReturnType<typeof useRemoveDocumentFromIngestionMutation>;
export type RemoveDocumentFromIngestionMutationResult = Apollo.MutationResult<GraphqlTypes.RemoveDocumentFromIngestionMutation>;
export type RemoveDocumentFromIngestionMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RemoveDocumentFromIngestionMutation, GraphqlTypes.RemoveDocumentFromIngestionMutationVariables>;
export const ApproveIngestionClassificationDocument = gql`
    mutation ApproveIngestionClassification($arenaId: Int!, $ingestionId: ID!) {
  approveIngestionClassification(arenaId: $arenaId, ingestionId: $ingestionId) {
    packages {
      packageId
      entityId
      reportingDate
      packageType
      documents {
        documentId
        documentVersion
      }
    }
  }
}
    `;
export type ApproveIngestionClassificationMutationFn = Apollo.MutationFunction<GraphqlTypes.ApproveIngestionClassificationMutation, GraphqlTypes.ApproveIngestionClassificationMutationVariables>;

/**
 * __useApproveIngestionClassificationMutation__
 *
 * To run a mutation, you first call `useApproveIngestionClassificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveIngestionClassificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveIngestionClassificationMutation, { data, loading, error }] = useApproveIngestionClassificationMutation({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      ingestionId: // value for 'ingestionId'
 *   },
 * });
 */
export function useApproveIngestionClassificationMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.ApproveIngestionClassificationMutation, GraphqlTypes.ApproveIngestionClassificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.ApproveIngestionClassificationMutation, GraphqlTypes.ApproveIngestionClassificationMutationVariables>(ApproveIngestionClassificationDocument, options);
      }
export type ApproveIngestionClassificationMutationHookResult = ReturnType<typeof useApproveIngestionClassificationMutation>;
export type ApproveIngestionClassificationMutationResult = Apollo.MutationResult<GraphqlTypes.ApproveIngestionClassificationMutation>;
export type ApproveIngestionClassificationMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.ApproveIngestionClassificationMutation, GraphqlTypes.ApproveIngestionClassificationMutationVariables>;
export const WorkflowEventsDocument = gql`
    subscription WorkflowEvents($workflowId: ID!, $sinceId: String! = "0") {
  workflowEvents(workflowId: $workflowId, sinceId: $sinceId) {
    id
    event {
      __typename
      ... on TimelineNodeUpserted {
        node {
          id
          parentId
          status
          summary
          payload {
            ...ClassificationPayload
          }
        }
      }
      ... on TimelineNodePatched {
        id
        status
        summary
        payload {
          ...ClassificationPayload
        }
      }
    }
  }
}
    ${ClassificationPayloadFragmentDoc}`;

/**
 * __useWorkflowEventsSubscription__
 *
 * To run a query within a React component, call `useWorkflowEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWorkflowEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkflowEventsSubscription({
 *   variables: {
 *      workflowId: // value for 'workflowId'
 *      sinceId: // value for 'sinceId'
 *   },
 * });
 */
export function useWorkflowEventsSubscription(baseOptions: Apollo.SubscriptionHookOptions<GraphqlTypes.WorkflowEventsSubscription, GraphqlTypes.WorkflowEventsSubscriptionVariables> & ({ variables: GraphqlTypes.WorkflowEventsSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<GraphqlTypes.WorkflowEventsSubscription, GraphqlTypes.WorkflowEventsSubscriptionVariables>(WorkflowEventsDocument, options);
      }
export type WorkflowEventsSubscriptionHookResult = ReturnType<typeof useWorkflowEventsSubscription>;
export type WorkflowEventsSubscriptionResult = Apollo.SubscriptionResult<GraphqlTypes.WorkflowEventsSubscription>;
export const CoverageViewDocument = gql`
    query CoverageView($input: CoverageViewInput!) {
  coverageView(input: $input) {
    periods
    rows {
      fund {
        id
        name
        isFaLocked
      }
      cells {
        period
        state
        cellId
      }
    }
  }
}
    `;

/**
 * __useCoverageViewQuery__
 *
 * To run a query within a React component, call `useCoverageViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverageViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverageViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCoverageViewQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.CoverageViewQuery, GraphqlTypes.CoverageViewQueryVariables> & ({ variables: GraphqlTypes.CoverageViewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CoverageViewQuery, GraphqlTypes.CoverageViewQueryVariables>(CoverageViewDocument, options);
      }
export function useCoverageViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CoverageViewQuery, GraphqlTypes.CoverageViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CoverageViewQuery, GraphqlTypes.CoverageViewQueryVariables>(CoverageViewDocument, options);
        }
// @ts-ignore
export function useCoverageViewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CoverageViewQuery, GraphqlTypes.CoverageViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CoverageViewQuery, GraphqlTypes.CoverageViewQueryVariables>;
export function useCoverageViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CoverageViewQuery, GraphqlTypes.CoverageViewQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CoverageViewQuery | undefined, GraphqlTypes.CoverageViewQueryVariables>;
export function useCoverageViewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CoverageViewQuery, GraphqlTypes.CoverageViewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CoverageViewQuery, GraphqlTypes.CoverageViewQueryVariables>(CoverageViewDocument, options);
        }
export type CoverageViewQueryHookResult = ReturnType<typeof useCoverageViewQuery>;
export type CoverageViewLazyQueryHookResult = ReturnType<typeof useCoverageViewLazyQuery>;
export type CoverageViewSuspenseQueryHookResult = ReturnType<typeof useCoverageViewSuspenseQuery>;
export type CoverageViewQueryResult = Apollo.QueryResult<GraphqlTypes.CoverageViewQuery, GraphqlTypes.CoverageViewQueryVariables>;
export const PackageDetailDocument = gql`
    query PackageDetail($arenaId: Int!, $id: ID!) {
  package(arenaId: $arenaId, id: $id) {
    ...PackageDetailFields
  }
}
    ${PackageDetailFieldsFragmentDoc}`;

/**
 * __usePackageDetailQuery__
 *
 * To run a query within a React component, call `usePackageDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageDetailQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePackageDetailQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.PackageDetailQuery, GraphqlTypes.PackageDetailQueryVariables> & ({ variables: GraphqlTypes.PackageDetailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.PackageDetailQuery, GraphqlTypes.PackageDetailQueryVariables>(PackageDetailDocument, options);
      }
export function usePackageDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.PackageDetailQuery, GraphqlTypes.PackageDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.PackageDetailQuery, GraphqlTypes.PackageDetailQueryVariables>(PackageDetailDocument, options);
        }
// @ts-ignore
export function usePackageDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.PackageDetailQuery, GraphqlTypes.PackageDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PackageDetailQuery, GraphqlTypes.PackageDetailQueryVariables>;
export function usePackageDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PackageDetailQuery, GraphqlTypes.PackageDetailQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PackageDetailQuery | undefined, GraphqlTypes.PackageDetailQueryVariables>;
export function usePackageDetailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PackageDetailQuery, GraphqlTypes.PackageDetailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.PackageDetailQuery, GraphqlTypes.PackageDetailQueryVariables>(PackageDetailDocument, options);
        }
export type PackageDetailQueryHookResult = ReturnType<typeof usePackageDetailQuery>;
export type PackageDetailLazyQueryHookResult = ReturnType<typeof usePackageDetailLazyQuery>;
export type PackageDetailSuspenseQueryHookResult = ReturnType<typeof usePackageDetailSuspenseQuery>;
export type PackageDetailQueryResult = Apollo.QueryResult<GraphqlTypes.PackageDetailQuery, GraphqlTypes.PackageDetailQueryVariables>;
export const RemoveDocumentFromPackageDocument = gql`
    mutation RemoveDocumentFromPackage($input: RemoveDocumentFromPackageInput!) {
  removeDocumentFromPackage(input: $input) {
    package {
      ...PackageDetailFields
    }
  }
}
    ${PackageDetailFieldsFragmentDoc}`;
export type RemoveDocumentFromPackageMutationFn = Apollo.MutationFunction<GraphqlTypes.RemoveDocumentFromPackageMutation, GraphqlTypes.RemoveDocumentFromPackageMutationVariables>;

/**
 * __useRemoveDocumentFromPackageMutation__
 *
 * To run a mutation, you first call `useRemoveDocumentFromPackageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveDocumentFromPackageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeDocumentFromPackageMutation, { data, loading, error }] = useRemoveDocumentFromPackageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveDocumentFromPackageMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.RemoveDocumentFromPackageMutation, GraphqlTypes.RemoveDocumentFromPackageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.RemoveDocumentFromPackageMutation, GraphqlTypes.RemoveDocumentFromPackageMutationVariables>(RemoveDocumentFromPackageDocument, options);
      }
export type RemoveDocumentFromPackageMutationHookResult = ReturnType<typeof useRemoveDocumentFromPackageMutation>;
export type RemoveDocumentFromPackageMutationResult = Apollo.MutationResult<GraphqlTypes.RemoveDocumentFromPackageMutation>;
export type RemoveDocumentFromPackageMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.RemoveDocumentFromPackageMutation, GraphqlTypes.RemoveDocumentFromPackageMutationVariables>;
export const UpdatePackageStateDocument = gql`
    mutation UpdatePackageState($input: UpdatePackageStateInput!) {
  updatePackageState(input: $input) {
    ...PackageDetailFields
  }
}
    ${PackageDetailFieldsFragmentDoc}`;
export type UpdatePackageStateMutationFn = Apollo.MutationFunction<GraphqlTypes.UpdatePackageStateMutation, GraphqlTypes.UpdatePackageStateMutationVariables>;

/**
 * __useUpdatePackageStateMutation__
 *
 * To run a mutation, you first call `useUpdatePackageStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageStateMutation, { data, loading, error }] = useUpdatePackageStateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePackageStateMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.UpdatePackageStateMutation, GraphqlTypes.UpdatePackageStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.UpdatePackageStateMutation, GraphqlTypes.UpdatePackageStateMutationVariables>(UpdatePackageStateDocument, options);
      }
export type UpdatePackageStateMutationHookResult = ReturnType<typeof useUpdatePackageStateMutation>;
export type UpdatePackageStateMutationResult = Apollo.MutationResult<GraphqlTypes.UpdatePackageStateMutation>;
export type UpdatePackageStateMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.UpdatePackageStateMutation, GraphqlTypes.UpdatePackageStateMutationVariables>;
export const FayUploaderNameDocument = gql`
    query FayUploaderName($userId: ID!) {
  staffUser(userId: $userId) {
    id
    fullName
  }
}
    `;

/**
 * __useFayUploaderNameQuery__
 *
 * To run a query within a React component, call `useFayUploaderNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useFayUploaderNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFayUploaderNameQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFayUploaderNameQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.FayUploaderNameQuery, GraphqlTypes.FayUploaderNameQueryVariables> & ({ variables: GraphqlTypes.FayUploaderNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.FayUploaderNameQuery, GraphqlTypes.FayUploaderNameQueryVariables>(FayUploaderNameDocument, options);
      }
export function useFayUploaderNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.FayUploaderNameQuery, GraphqlTypes.FayUploaderNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.FayUploaderNameQuery, GraphqlTypes.FayUploaderNameQueryVariables>(FayUploaderNameDocument, options);
        }
// @ts-ignore
export function useFayUploaderNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.FayUploaderNameQuery, GraphqlTypes.FayUploaderNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FayUploaderNameQuery, GraphqlTypes.FayUploaderNameQueryVariables>;
export function useFayUploaderNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FayUploaderNameQuery, GraphqlTypes.FayUploaderNameQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FayUploaderNameQuery | undefined, GraphqlTypes.FayUploaderNameQueryVariables>;
export function useFayUploaderNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FayUploaderNameQuery, GraphqlTypes.FayUploaderNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.FayUploaderNameQuery, GraphqlTypes.FayUploaderNameQueryVariables>(FayUploaderNameDocument, options);
        }
export type FayUploaderNameQueryHookResult = ReturnType<typeof useFayUploaderNameQuery>;
export type FayUploaderNameLazyQueryHookResult = ReturnType<typeof useFayUploaderNameLazyQuery>;
export type FayUploaderNameSuspenseQueryHookResult = ReturnType<typeof useFayUploaderNameSuspenseQuery>;
export type FayUploaderNameQueryResult = Apollo.QueryResult<GraphqlTypes.FayUploaderNameQuery, GraphqlTypes.FayUploaderNameQueryVariables>;
export const TriageFindingDocument = gql`
    mutation TriageFinding($input: TriageFindingInput!) {
  triageFinding(input: $input) {
    findingId
    checkId
    triageState
  }
}
    `;
export type TriageFindingMutationFn = Apollo.MutationFunction<GraphqlTypes.TriageFindingMutation, GraphqlTypes.TriageFindingMutationVariables>;

/**
 * __useTriageFindingMutation__
 *
 * To run a mutation, you first call `useTriageFindingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTriageFindingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [triageFindingMutation, { data, loading, error }] = useTriageFindingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTriageFindingMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.TriageFindingMutation, GraphqlTypes.TriageFindingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.TriageFindingMutation, GraphqlTypes.TriageFindingMutationVariables>(TriageFindingDocument, options);
      }
export type TriageFindingMutationHookResult = ReturnType<typeof useTriageFindingMutation>;
export type TriageFindingMutationResult = Apollo.MutationResult<GraphqlTypes.TriageFindingMutation>;
export type TriageFindingMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.TriageFindingMutation, GraphqlTypes.TriageFindingMutationVariables>;
export const SubmitFindingFeedbackDocument = gql`
    mutation SubmitFindingFeedback($input: SubmitFindingFeedbackInput!) {
  submitFindingFeedback(input: $input) {
    findingId
    feedback {
      rating
      note
      updatedByUserId
      updatedAt
    }
  }
}
    `;
export type SubmitFindingFeedbackMutationFn = Apollo.MutationFunction<GraphqlTypes.SubmitFindingFeedbackMutation, GraphqlTypes.SubmitFindingFeedbackMutationVariables>;

/**
 * __useSubmitFindingFeedbackMutation__
 *
 * To run a mutation, you first call `useSubmitFindingFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFindingFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFindingFeedbackMutation, { data, loading, error }] = useSubmitFindingFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitFindingFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<GraphqlTypes.SubmitFindingFeedbackMutation, GraphqlTypes.SubmitFindingFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GraphqlTypes.SubmitFindingFeedbackMutation, GraphqlTypes.SubmitFindingFeedbackMutationVariables>(SubmitFindingFeedbackDocument, options);
      }
export type SubmitFindingFeedbackMutationHookResult = ReturnType<typeof useSubmitFindingFeedbackMutation>;
export type SubmitFindingFeedbackMutationResult = Apollo.MutationResult<GraphqlTypes.SubmitFindingFeedbackMutation>;
export type SubmitFindingFeedbackMutationOptions = Apollo.BaseMutationOptions<GraphqlTypes.SubmitFindingFeedbackMutation, GraphqlTypes.SubmitFindingFeedbackMutationVariables>;
export const CoverageFundsDocument = gql`
    query CoverageFunds($input: CoverageFundsInput!) {
  coverageFunds(input: $input) {
    fund {
      id
    }
  }
}
    `;

/**
 * __useCoverageFundsQuery__
 *
 * To run a query within a React component, call `useCoverageFundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoverageFundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoverageFundsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCoverageFundsQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.CoverageFundsQuery, GraphqlTypes.CoverageFundsQueryVariables> & ({ variables: GraphqlTypes.CoverageFundsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.CoverageFundsQuery, GraphqlTypes.CoverageFundsQueryVariables>(CoverageFundsDocument, options);
      }
export function useCoverageFundsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.CoverageFundsQuery, GraphqlTypes.CoverageFundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.CoverageFundsQuery, GraphqlTypes.CoverageFundsQueryVariables>(CoverageFundsDocument, options);
        }
// @ts-ignore
export function useCoverageFundsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.CoverageFundsQuery, GraphqlTypes.CoverageFundsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CoverageFundsQuery, GraphqlTypes.CoverageFundsQueryVariables>;
export function useCoverageFundsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CoverageFundsQuery, GraphqlTypes.CoverageFundsQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.CoverageFundsQuery | undefined, GraphqlTypes.CoverageFundsQueryVariables>;
export function useCoverageFundsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.CoverageFundsQuery, GraphqlTypes.CoverageFundsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.CoverageFundsQuery, GraphqlTypes.CoverageFundsQueryVariables>(CoverageFundsDocument, options);
        }
export type CoverageFundsQueryHookResult = ReturnType<typeof useCoverageFundsQuery>;
export type CoverageFundsLazyQueryHookResult = ReturnType<typeof useCoverageFundsLazyQuery>;
export type CoverageFundsSuspenseQueryHookResult = ReturnType<typeof useCoverageFundsSuspenseQuery>;
export type CoverageFundsQueryResult = Apollo.QueryResult<GraphqlTypes.CoverageFundsQuery, GraphqlTypes.CoverageFundsQueryVariables>;
export const InvestmentEntityLookupDocument = gql`
    query InvestmentEntityLookup($search: String, $ids: [ID!]) {
  investmentEntities(filters: {nameSearchTerm: $search, ids: $ids}) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useInvestmentEntityLookupQuery__
 *
 * To run a query within a React component, call `useInvestmentEntityLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvestmentEntityLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvestmentEntityLookupQuery({
 *   variables: {
 *      search: // value for 'search'
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useInvestmentEntityLookupQuery(baseOptions?: Apollo.QueryHookOptions<GraphqlTypes.InvestmentEntityLookupQuery, GraphqlTypes.InvestmentEntityLookupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.InvestmentEntityLookupQuery, GraphqlTypes.InvestmentEntityLookupQueryVariables>(InvestmentEntityLookupDocument, options);
      }
export function useInvestmentEntityLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.InvestmentEntityLookupQuery, GraphqlTypes.InvestmentEntityLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.InvestmentEntityLookupQuery, GraphqlTypes.InvestmentEntityLookupQueryVariables>(InvestmentEntityLookupDocument, options);
        }
// @ts-ignore
export function useInvestmentEntityLookupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.InvestmentEntityLookupQuery, GraphqlTypes.InvestmentEntityLookupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.InvestmentEntityLookupQuery, GraphqlTypes.InvestmentEntityLookupQueryVariables>;
export function useInvestmentEntityLookupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.InvestmentEntityLookupQuery, GraphqlTypes.InvestmentEntityLookupQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.InvestmentEntityLookupQuery | undefined, GraphqlTypes.InvestmentEntityLookupQueryVariables>;
export function useInvestmentEntityLookupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.InvestmentEntityLookupQuery, GraphqlTypes.InvestmentEntityLookupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.InvestmentEntityLookupQuery, GraphqlTypes.InvestmentEntityLookupQueryVariables>(InvestmentEntityLookupDocument, options);
        }
export type InvestmentEntityLookupQueryHookResult = ReturnType<typeof useInvestmentEntityLookupQuery>;
export type InvestmentEntityLookupLazyQueryHookResult = ReturnType<typeof useInvestmentEntityLookupLazyQuery>;
export type InvestmentEntityLookupSuspenseQueryHookResult = ReturnType<typeof useInvestmentEntityLookupSuspenseQuery>;
export type InvestmentEntityLookupQueryResult = Apollo.QueryResult<GraphqlTypes.InvestmentEntityLookupQuery, GraphqlTypes.InvestmentEntityLookupQueryVariables>;
export const DocumentViewerUrlDocument = gql`
    query DocumentViewerUrl($arenaId: Int!, $documentId: ID!, $documentVersion: Int) {
  documentViewerUrl(
    arenaId: $arenaId
    documentId: $documentId
    documentVersion: $documentVersion
  ) {
    pdfUrl
    filename
    contentType
  }
}
    `;

/**
 * __useDocumentViewerUrlQuery__
 *
 * To run a query within a React component, call `useDocumentViewerUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentViewerUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentViewerUrlQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      documentId: // value for 'documentId'
 *      documentVersion: // value for 'documentVersion'
 *   },
 * });
 */
export function useDocumentViewerUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.DocumentViewerUrlQuery, GraphqlTypes.DocumentViewerUrlQueryVariables> & ({ variables: GraphqlTypes.DocumentViewerUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.DocumentViewerUrlQuery, GraphqlTypes.DocumentViewerUrlQueryVariables>(DocumentViewerUrlDocument, options);
      }
export function useDocumentViewerUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.DocumentViewerUrlQuery, GraphqlTypes.DocumentViewerUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.DocumentViewerUrlQuery, GraphqlTypes.DocumentViewerUrlQueryVariables>(DocumentViewerUrlDocument, options);
        }
// @ts-ignore
export function useDocumentViewerUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.DocumentViewerUrlQuery, GraphqlTypes.DocumentViewerUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DocumentViewerUrlQuery, GraphqlTypes.DocumentViewerUrlQueryVariables>;
export function useDocumentViewerUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DocumentViewerUrlQuery, GraphqlTypes.DocumentViewerUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.DocumentViewerUrlQuery | undefined, GraphqlTypes.DocumentViewerUrlQueryVariables>;
export function useDocumentViewerUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.DocumentViewerUrlQuery, GraphqlTypes.DocumentViewerUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.DocumentViewerUrlQuery, GraphqlTypes.DocumentViewerUrlQueryVariables>(DocumentViewerUrlDocument, options);
        }
export type DocumentViewerUrlQueryHookResult = ReturnType<typeof useDocumentViewerUrlQuery>;
export type DocumentViewerUrlLazyQueryHookResult = ReturnType<typeof useDocumentViewerUrlLazyQuery>;
export type DocumentViewerUrlSuspenseQueryHookResult = ReturnType<typeof useDocumentViewerUrlSuspenseQuery>;
export type DocumentViewerUrlQueryResult = Apollo.QueryResult<GraphqlTypes.DocumentViewerUrlQuery, GraphqlTypes.DocumentViewerUrlQueryVariables>;
export const FayDocumentDownloadUrlDocument = gql`
    query FayDocumentDownloadUrl($arenaId: Int!, $documentId: ID!, $documentVersion: Int) {
  fayDocumentDownloadUrl(
    arenaId: $arenaId
    documentId: $documentId
    documentVersion: $documentVersion
  ) {
    downloadUrl
    filename
    contentType
  }
}
    `;

/**
 * __useFayDocumentDownloadUrlQuery__
 *
 * To run a query within a React component, call `useFayDocumentDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useFayDocumentDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFayDocumentDownloadUrlQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      documentId: // value for 'documentId'
 *      documentVersion: // value for 'documentVersion'
 *   },
 * });
 */
export function useFayDocumentDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.FayDocumentDownloadUrlQuery, GraphqlTypes.FayDocumentDownloadUrlQueryVariables> & ({ variables: GraphqlTypes.FayDocumentDownloadUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.FayDocumentDownloadUrlQuery, GraphqlTypes.FayDocumentDownloadUrlQueryVariables>(FayDocumentDownloadUrlDocument, options);
      }
export function useFayDocumentDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.FayDocumentDownloadUrlQuery, GraphqlTypes.FayDocumentDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.FayDocumentDownloadUrlQuery, GraphqlTypes.FayDocumentDownloadUrlQueryVariables>(FayDocumentDownloadUrlDocument, options);
        }
// @ts-ignore
export function useFayDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.FayDocumentDownloadUrlQuery, GraphqlTypes.FayDocumentDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FayDocumentDownloadUrlQuery, GraphqlTypes.FayDocumentDownloadUrlQueryVariables>;
export function useFayDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FayDocumentDownloadUrlQuery, GraphqlTypes.FayDocumentDownloadUrlQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.FayDocumentDownloadUrlQuery | undefined, GraphqlTypes.FayDocumentDownloadUrlQueryVariables>;
export function useFayDocumentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.FayDocumentDownloadUrlQuery, GraphqlTypes.FayDocumentDownloadUrlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.FayDocumentDownloadUrlQuery, GraphqlTypes.FayDocumentDownloadUrlQueryVariables>(FayDocumentDownloadUrlDocument, options);
        }
export type FayDocumentDownloadUrlQueryHookResult = ReturnType<typeof useFayDocumentDownloadUrlQuery>;
export type FayDocumentDownloadUrlLazyQueryHookResult = ReturnType<typeof useFayDocumentDownloadUrlLazyQuery>;
export type FayDocumentDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useFayDocumentDownloadUrlSuspenseQuery>;
export type FayDocumentDownloadUrlQueryResult = Apollo.QueryResult<GraphqlTypes.FayDocumentDownloadUrlQuery, GraphqlTypes.FayDocumentDownloadUrlQueryVariables>;
export const PackageActivitiesDocument = gql`
    query PackageActivities($arenaId: Int!, $packageId: ID!) {
  packageActivities(arenaId: $arenaId, packageId: $packageId) {
    id
    name
    activityType
    summary
  }
}
    `;

/**
 * __usePackageActivitiesQuery__
 *
 * To run a query within a React component, call `usePackageActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageActivitiesQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function usePackageActivitiesQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.PackageActivitiesQuery, GraphqlTypes.PackageActivitiesQueryVariables> & ({ variables: GraphqlTypes.PackageActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.PackageActivitiesQuery, GraphqlTypes.PackageActivitiesQueryVariables>(PackageActivitiesDocument, options);
      }
export function usePackageActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.PackageActivitiesQuery, GraphqlTypes.PackageActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.PackageActivitiesQuery, GraphqlTypes.PackageActivitiesQueryVariables>(PackageActivitiesDocument, options);
        }
// @ts-ignore
export function usePackageActivitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.PackageActivitiesQuery, GraphqlTypes.PackageActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PackageActivitiesQuery, GraphqlTypes.PackageActivitiesQueryVariables>;
export function usePackageActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PackageActivitiesQuery, GraphqlTypes.PackageActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PackageActivitiesQuery | undefined, GraphqlTypes.PackageActivitiesQueryVariables>;
export function usePackageActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PackageActivitiesQuery, GraphqlTypes.PackageActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.PackageActivitiesQuery, GraphqlTypes.PackageActivitiesQueryVariables>(PackageActivitiesDocument, options);
        }
export type PackageActivitiesQueryHookResult = ReturnType<typeof usePackageActivitiesQuery>;
export type PackageActivitiesLazyQueryHookResult = ReturnType<typeof usePackageActivitiesLazyQuery>;
export type PackageActivitiesSuspenseQueryHookResult = ReturnType<typeof usePackageActivitiesSuspenseQuery>;
export type PackageActivitiesQueryResult = Apollo.QueryResult<GraphqlTypes.PackageActivitiesQuery, GraphqlTypes.PackageActivitiesQueryVariables>;
export const PackageActivityDocument = gql`
    query PackageActivity($arenaId: Int!, $id: ID!) {
  packageActivity(arenaId: $arenaId, id: $id) {
    id
    name
    activityType
    summary
    reviewNotes {
      id
      ordinal
      content
      docType
      outcome
      evaluatedAt
    }
    sources {
      source
      sourceType
      url
    }
  }
}
    `;

/**
 * __usePackageActivityQuery__
 *
 * To run a query within a React component, call `usePackageActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageActivityQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePackageActivityQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.PackageActivityQuery, GraphqlTypes.PackageActivityQueryVariables> & ({ variables: GraphqlTypes.PackageActivityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.PackageActivityQuery, GraphqlTypes.PackageActivityQueryVariables>(PackageActivityDocument, options);
      }
export function usePackageActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.PackageActivityQuery, GraphqlTypes.PackageActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.PackageActivityQuery, GraphqlTypes.PackageActivityQueryVariables>(PackageActivityDocument, options);
        }
// @ts-ignore
export function usePackageActivitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.PackageActivityQuery, GraphqlTypes.PackageActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PackageActivityQuery, GraphqlTypes.PackageActivityQueryVariables>;
export function usePackageActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PackageActivityQuery, GraphqlTypes.PackageActivityQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PackageActivityQuery | undefined, GraphqlTypes.PackageActivityQueryVariables>;
export function usePackageActivitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PackageActivityQuery, GraphqlTypes.PackageActivityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.PackageActivityQuery, GraphqlTypes.PackageActivityQueryVariables>(PackageActivityDocument, options);
        }
export type PackageActivityQueryHookResult = ReturnType<typeof usePackageActivityQuery>;
export type PackageActivityLazyQueryHookResult = ReturnType<typeof usePackageActivityLazyQuery>;
export type PackageActivitySuspenseQueryHookResult = ReturnType<typeof usePackageActivitySuspenseQuery>;
export type PackageActivityQueryResult = Apollo.QueryResult<GraphqlTypes.PackageActivityQuery, GraphqlTypes.PackageActivityQueryVariables>;
export const PackageActivityCheckStatusDocument = gql`
    query PackageActivityCheckStatus($arenaId: Int!, $packageId: ID!) {
  packageEntityActivityCheckStatus(arenaId: $arenaId, packageId: $packageId) {
    total
    passed
    failed
    skipped
    notEvaluated
  }
}
    `;

/**
 * __usePackageActivityCheckStatusQuery__
 *
 * To run a query within a React component, call `usePackageActivityCheckStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageActivityCheckStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageActivityCheckStatusQuery({
 *   variables: {
 *      arenaId: // value for 'arenaId'
 *      packageId: // value for 'packageId'
 *   },
 * });
 */
export function usePackageActivityCheckStatusQuery(baseOptions: Apollo.QueryHookOptions<GraphqlTypes.PackageActivityCheckStatusQuery, GraphqlTypes.PackageActivityCheckStatusQueryVariables> & ({ variables: GraphqlTypes.PackageActivityCheckStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GraphqlTypes.PackageActivityCheckStatusQuery, GraphqlTypes.PackageActivityCheckStatusQueryVariables>(PackageActivityCheckStatusDocument, options);
      }
export function usePackageActivityCheckStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GraphqlTypes.PackageActivityCheckStatusQuery, GraphqlTypes.PackageActivityCheckStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GraphqlTypes.PackageActivityCheckStatusQuery, GraphqlTypes.PackageActivityCheckStatusQueryVariables>(PackageActivityCheckStatusDocument, options);
        }
// @ts-ignore
export function usePackageActivityCheckStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GraphqlTypes.PackageActivityCheckStatusQuery, GraphqlTypes.PackageActivityCheckStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PackageActivityCheckStatusQuery, GraphqlTypes.PackageActivityCheckStatusQueryVariables>;
export function usePackageActivityCheckStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PackageActivityCheckStatusQuery, GraphqlTypes.PackageActivityCheckStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GraphqlTypes.PackageActivityCheckStatusQuery | undefined, GraphqlTypes.PackageActivityCheckStatusQueryVariables>;
export function usePackageActivityCheckStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GraphqlTypes.PackageActivityCheckStatusQuery, GraphqlTypes.PackageActivityCheckStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GraphqlTypes.PackageActivityCheckStatusQuery, GraphqlTypes.PackageActivityCheckStatusQueryVariables>(PackageActivityCheckStatusDocument, options);
        }
export type PackageActivityCheckStatusQueryHookResult = ReturnType<typeof usePackageActivityCheckStatusQuery>;
export type PackageActivityCheckStatusLazyQueryHookResult = ReturnType<typeof usePackageActivityCheckStatusLazyQuery>;
export type PackageActivityCheckStatusSuspenseQueryHookResult = ReturnType<typeof usePackageActivityCheckStatusSuspenseQuery>;
export type PackageActivityCheckStatusQueryResult = Apollo.QueryResult<GraphqlTypes.PackageActivityCheckStatusQuery, GraphqlTypes.PackageActivityCheckStatusQueryVariables>;